var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconrfidTags = function SvgIconrfidTags(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Settings/icon.rfid_tags") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "17.5154729%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.251966783,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Settings/icon.rfid_tags",
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "group",
    fill: "#D9E8E3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.75,0 C18.2393458,0 23.5,5.26065419 23.5,11.75 C23.5,18.2393458 18.2393458,23.5 11.75,23.5 C5.26065419,23.5 0,18.2393458 0,11.75 C0,5.26065419 5.26065419,0 11.75,0 Z",
    id: "Path_508"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.0108, 5.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9892224,4.63273864e-12 L12.39659,1.35003891 L13.4863891,2.39544547 L14.5814463,3.44589585 L15.6876557,4.50704428 L16.798137,5.57229043 L17.896059,6.625489 L18.9217926,7.60943973 C16.4840042,9.86981324 13.8434067,11 11,11 C8.15659332,11 5.50881072,9.86981324 3.05665219,7.60943973 L4.17733355,6.53440894 L5.24725795,5.50806754 L6.33332422,4.4662418 L7.4179048,3.42584123 L8.59041324,2.30109452 L9.59109719,1.34117308 L10.9892224,4.63273864e-12 Z",
    id: "Triangle",
    fill: "url(#linearGradient-1)",
    transform: "translate(10.9892, 5.5) scale(1, -1) translate(-10.9892, -5.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9217926,3.36812845 C16.9209103,1.29171857 14.1113037,0 11,0 C7.87750754,0 5.05888593,1.30102576 3.05665219,3.39056027",
    id: "Path",
    stroke: "#09BE86",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7814073,5.47048582 C15.3249665,3.9481201 13.2732059,3 11,3 C8.69811128,3 6.62329142,3.97219739 5.16374663,5.52838595",
    id: "Path",
    stroke: "#09BE86",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7015004,7.63856385 C13.7868454,6.63197442 12.4672255,6 11,6 C9.52572518,6 8.20047765,6.6380617 7.28534415,7.65309837",
    id: "Path",
    stroke: "#09BE86",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#09BE86",
    fill: "#FFFFFF",
    cx: 11,
    cy: 11,
    r: 2
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconrfidTags);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.rfid_tags.e01bb14f18f4fc2656b5b583242ae74c.svg";